import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { ShippingConfig } from "@/hooks/cart/cartTotals";

export function useShippingConfig() {
  return useQuery<ShippingConfig>({
    queryKey: ["shipping-config"],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke("public-settings");
      if (error || !data) {
        return { freeShippingThreshold: 50, shippingFeeAmount: 6.90 };
      }
      return {
        freeShippingThreshold: Number(data.free_shipping_threshold) || 50,
        shippingFeeAmount: Number(data.shipping_fee_amount) || 6.90,
      };
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
